import { gql } from '../../../apollo/__generated__';

export const JOIN_EVENT = gql(`
  mutation JoinEvent($joinEventInput: JoinEventInput!) {
    joinEvent(joinEventInput: $joinEventInput) {
      id
      hasJoined
      waitingListPosition
    }
  }
`);
